<template>
  <v-card max-width="100%" outlined>
    <v-app-bar dark dense color="red lighten-1" elevation="0">
      <v-toolbar-title>Lista de Itens Transferidos</v-toolbar-title>
      <NewTransfer />
    </v-app-bar>
    <v-data-table
      :headers="headers"
      :items="movements"
      :items-per-page="5"
      :search="search"
      :custom-filter="filterMovements"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field v-model="search" label="Pesquisar" class="mx-4"></v-text-field>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row v-if="item.movement_status_id == 2">
          <v-col class="d-flex">
            <TransferDetail :movementId="item.id" />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="2" xs="5" sm="5" md="2" lg="2" xl="2" class="justify-start mr-4">
            <TransferDocumentUpload :movementId="item.id" />
          </v-col>

          <!-- <v-col cols="2" xs="5" sm="5" md="2" lg="2" xl="2" class="justify-center">
            <EditTransfer :movementId="item.id" />
          </v-col> -->

          <v-col cols="2" xs="5" sm="5" md="2" lg="2" xl="2" class="justify-center mt-1">
            <v-row>
              <v-col cols="12" class="d-flex">
                <a
                  :href="base_url + '/movement_document/' + item.id"
                  target="_blank"
                  style="text-decoration: none"
                  ><v-icon medium color="red lighten-1"> mdi-download </v-icon></a
                >
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="2" xs="5" sm="5" md="2" lg="2" xl="2" class="justify-end ml-0">
            <v-row>
              <v-col class="d-flex">
                <v-btn text medium icon @click="modalDeleteMovement(item.id)">
                  <v-icon medium color="red lighten-1"> mdi-close-box-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import NewTransfer from '@/views/transfer/components/NewTransfer'
import TransferDetail from '@/views/transfer/components/TransferDetail'
import TransferDocumentUpload from '@/views/transfer/components/TransferDocumentUpload'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'ListTransfers',
  components: { NewTransfer, TransferDetail, TransferDocumentUpload },
  data() {
    return {
      base_url: process.env.VUE_APP_BASE_URL,
      search: '',
      headers: [
        {
          text: 'Documento de Transferencia',
          align: 'start',
          value: 'movement_document_number',
        },
        { text: 'Tipo de Tranferência', value: 'movement_type' },
        { text: 'Entidade Receptora', value: 'reciever_entity' },
        { text: 'Data da Transferência', value: 'movement_date' },
        { text: '', value: 'actions', sortable: false },
      ],
    }
  },
  computed: {
    ...mapState('movements', ['movements']),
    ...mapState('assets', ['assets']),
  },
  methods: {
    ...mapActions('movements', ['ActionDeleteMovement']),
    ...mapActions('ui', ['ActionSetLoading']),

    modalDeleteMovement(movementId) {
      this.$swal({
        icon: 'warning',
        title: 'Deletar',
        text: 'Deseja realmente deletar este registro de transferencia?',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            this.ActionSetLoading(true)
            await this.ActionDeleteMovement(movementId)
            this.ActionSetLoading(false)
            this.$swal({
              icon: 'success',
              title: 'Deletado',
              text: 'Registro de transferencia deletado com sucesso',
            })
          } catch (error) {
            if (error.body) {
              if (error.status != 422) {
                this.$swal({
                  icon: 'error',
                  title: 'Erro',
                  text: error.body.message,
                })
              } else if (error.body.errors) {
                Object.keys(error.body.errors).map((key) => {
                  this.errors.data[key] = error.body.errors[key]
                })
              }
            }
            this.ActionSetLoading(false)
          }
        }
      })
    },

    filterMovements(value, search, item) {
      search = search.toUpperCase()

      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      )
    },
  },
}
</script>
